import axios from 'axios';


export const API_URL = 'https://solar.fir-india.com/api/v1'; 
//export const API_URL = 'http://localhost:5000/api/v1';
export const axiosInstance = axios.create({
      baseURL: API_URL
    });

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token'); // Or wherever your token is stored
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 errors (Unauthorized)
    if (error.response && 
        (error.response.status === 401 || (error.response.status === 422 && error.response.data.msg === "Signature verification failed"))) {
      // Optionally, you can redirect to login page or refresh token
      alert("Unauthorized! Please log in again.");
      localStorage.removeItem('access_token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_name');
      localStorage.removeItem('role_id');
      localStorage.removeItem('role_name');
      window.location.href = '/login'; // Example redirect
    }
    return Promise.reject(error);
  }

)